let Signatures = require('@/mixins/Signatures')

module.exports = {

    mixins: [Signatures],

    mounted() {
        this.signaturePad = new SignaturePad(
            document.getElementById("signature-pad")
        );
    },

    methods: {

        save() {
            this.prepareData()
            this.form.post(`/projects/${this.project.slug}/acceptance-documents`).then(response => {
                this.redirectTo(`/projects/${this.project.slug}/acceptance-documents`);
            }).catch(errors => {
                Alert.error(errors.first())
            })
        },
    },
}
